<template>
  <el-dialog  :title="title" :visible.sync="showDialog" :modal-append-to-body=false width="600px"  v-dialog-drag :destroy-on-close="true" :modal=false  :before-close="cancel">
    <el-form label-width="90px" ref="form" :model="form" :rules="rules">
      <el-form-item label="取消原因:" prop="rejection_reason">
        <el-input :rows="5" type="textarea" maxlength="300" show-word-limit
                  placeholder="请输入内容" v-model="form.rejection_reason">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button size="small" type="primary" class="title" @click="handle">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>

import {notMail} from "@/api/dilivery/mail";
import {needRedDoltInfo} from "@/utils/data/basicData/leftNavData";
import {notArrangeMail} from "@/api/dilivery/material/request";
import {getDataInLocalStorage} from "@/utils/localStorage";

export default {
  name: "NotArrangeMail",
  props:['showDialog','selectType','selectDetail'],
  data(){
    return{
      title: '',
      form:{
        rejection_reason:''
      },
      rules: {
        rejection_reason: [
          {required: true,message: '请填写取消理由', trigger: 'change'}
        ]
      },
    }
  },
  watch:{
    'selectType':{
      handler(newVal){
        if (newVal){
          if(newVal==='mail'){
            this.title='取消邮寄'
          }else if(newVal === 'dryIce'){
            this.title='取消干冰安排'
          }else{
            this.title='取消物料邮寄'
          }
        }
      },
      immediate:true
    },
    'selectDetail':{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.form.id = newVal.id
        }
      },
      immediate:true
    },
  },

  methods:{
    cancel(){
      this.$emit('submit','cancel')
    },
    handle(){
      this.$refs.form.validate(valid=>{
        if(valid){
          if (this.selectType === 'mail') {
            notMail(this.form).then(res => {
              if (res.code === 200) {
                this.$emit('submit','confirm')
                this.$messageUi.success('取消成功')
                this.$store.commit('right/setChangeRed',true)
              }
            }).catch(err => {
            })
          } else if(this.selectType === 'dryIce') {
            notArrangeMail(this.form).then(res => {
              if (res.code === 200) {
                this.$emit('submit','confirm')
                this.$messageUi.success('取消成功')
                this.$store.commit('right/setChangeRed',true)
              }
            }).catch(err => {
            })
          } else {
            notArrangeMail(this.form).then(res => {
              if (res.code === 200) {
                this.$emit('submit','confirm')
                this.$messageUi.success('取消成功')
                this.$store.commit('right/setChangeRed',true)
              }
            }).catch(err => {
            })
          }
        }else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      })
    }
  },

}
</script>

<style scoped>

</style>
